type Props = {
  text?: string
}

const AssignmentScopeReminderText = ({ text }: Props) => {
  if (!text) return null
  return <span className='text-info-foreground ml-2'>&quot;{text}&quot;</span>
}

export default AssignmentScopeReminderText
